<app-planning-region-actions
  [data]="data"
  [regions]="regions"
/>

@if (!loadingInitial) {
  <div class="container-fluid mt-1" >
    <div class="table-container">
      <div class="header-container d-flex align-items-center">
        <button class="btn btn-primary" (click)="navigateTable(-1)">&#9664;</button>
        <div class="date-picker-container">
          <input
            class="form-control datepicker-input"
            [formControl]="dateControl"
            ngbDatepicker
            #d="ngbDatepicker"
            [firstDayOfWeek]="3"
          />
          <button
            class="btn btn-outline-secondary bi bi-calendar3"
            (click)="d.toggle()"
            type="button"
          >
          </button>
        </div>
        <button class="btn btn-primary" (click)="navigateTable(1)">&#9654;</button>
      </div>
        <div class="table-wrapper">
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                @for (cinema of data.cinemas; track cinema.id_cinema) {
                  @let cinemasScreensLength = cinema.screens?.length;
                  @for (screen of cinema.screens; track screen.screen_id) {
                    <th
                      app-planning-region-header
                      [screen]="screen"
                      [dateValue]="dateControl.value"
                      [data]="data"
                      class="screen-header"
                      [ngClass]="{'screen-header-cinema': cinemasScreensLength == ($index + 1)}"
                    >
                    </th>
                  }
                }
              </tr>
            </thead>
              <tbody
                app-planning-region-week
                [data]="data"
                [dateValue]="dateControl.value"
                (loadRegionData)="loadRegionData($event)">
              </tbody>
          </table>
        </div>
    </div>
  </div>
}
@else {
  <div class="spinner-container">
    <app-progress-spinner />
  </div>
}
